module.exports = __webpack_public_path__ + "img/youtube.10f28e64.svg";